"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section ref={ref} className="relative min-h-[70vh] flex items-center justify-center px-6 py-24 overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 opacity-30" style={{
      backgroundImage: `radial-gradient(circle at 20% 30%, hsl(220, 80%, 50%) 0.5px, transparent 0.5px),
                            radial-gradient(circle at 80% 70%, hsl(0, 0%, 100%) 0.3px, transparent 0.3px),
                            radial-gradient(circle at 40% 80%, hsl(220, 80%, 50%) 0.4px, transparent 0.4px),
                            radial-gradient(circle at 60% 20%, hsl(0, 0%, 100%) 0.6px, transparent 0.6px)`,
      backgroundSize: "200px 200px, 300px 300px, 250px 250px, 180px 180px",
      backgroundPosition: "0 0, 50px 50px, 100px 0, 150px 100px"
    }} />

      {}
      <div className={`relative z-10 max-w-3xl mx-auto text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <h2 className="text-foreground mb-6 leading-tight !text-[42px]">
          Prêt à maîtriser la complexité et créer de la valeur durable ?
        </h2>
        <p className="text-muted-foreground mb-10 max-w-2xl mx-auto"></p>

        <Link to="#contact">
          <Button size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover active:bg-primary-active shadow-medium transition-all duration-[150ms] ease-[var(--ease-spring)] hover:scale-[1.03] active:scale-100">&nbsp;Démarrer ensemble</Button>
        </Link>
      </div>
    </section>;
}